import React from 'react';
import Styles from './ToyotaCorolla.module.css';
import Carousel from '../../../../components/Carousel/Carousel';
import {cars} from './Data';
import Hero from '../HeroForm/Hero';

const ToyotaCorolla = () => {
  return (
    
     <div className={Styles.main_page}>
     <h2>Toyota Corolla</h2>
     {/*Carousel*/}
     <div className={Styles.car_image}>
       <Carousel images={cars} />
     </div>
    <Hero selectedCar="Toyota Corolla" /> 
   </div>
  );
}

export default ToyotaCorolla;
